/**
 * A starting name for a passkey made on this device, so a list of them reads
 * "Mac", "iPhone" rather than "Passkey", "Passkey". The user can rename it.
 * Undefined when the device is not recognisable; the api then names it
 * "Passkey".
 *
 * Order matters: iPadOS reports itself as a Mac unless it has touch points,
 * and Android's user agent also says "Linux".
 */
export function suggestPasskeyLabel(
  userAgent: string = globalThis.navigator?.userAgent ?? '',
  maxTouchPoints: number = globalThis.navigator?.maxTouchPoints ?? 0
): string | undefined {
  if (/iPhone/.test(userAgent)) {
    return 'iPhone'
  }
  if (
    /iPad/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && maxTouchPoints > 1)
  ) {
    return 'iPad'
  }
  if (/Android/.test(userAgent)) {
    return 'Android'
  }
  if (/Macintosh|Mac OS X/.test(userAgent)) {
    return 'Mac'
  }
  if (/Windows/.test(userAgent)) {
    return 'Windows'
  }
  if (/CrOS/.test(userAgent)) {
    return 'Chromebook'
  }
  if (/Linux/.test(userAgent)) {
    return 'Linux'
  }
  return undefined
}
